import { styled, Avatar, Typography } from '@mui/material';

import { BillingItemCompanyType } from '~services/billingItem/types';

export const BillingItemCompanyInfoContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: number }>(({ theme, size }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: theme.typography.pxToRem(size),
}));

export const BillingItemCompanyInfoAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'type',
})<{ size: number; type: BillingItemCompanyType }>(({ theme, size, type }) => ({
  [`&, &.MuiChip-avatarSmall`]: {
    fontSize: theme.typography.pxToRem(size - 1.7),
    width: size * 1.7,
    height: size * 1.7,
    color: theme.palette.common.white,

    ...(type === 'company' && {
      backgroundColor: theme.palette.primary.light,
    }),

    ...(type === 'integration' && {
      backgroundColor: theme.palette.warning.light,
    }),

    ...(type === 'giver' && {
      backgroundColor: theme.palette.info.light,
    }),
  },
}));

export const BillingItemCompanyInfoTypography = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
